import HTMLTemplate from './template.html'
import './../EventPanel/styles.scss' // Might need to look at improving this later - DRS
import './../EventDetailsPanel/styles.scss' // Might need to look at improving this later - DRS
import './styles.scss'
import moment from 'moment'
import 'moment-timezone'

export const InternationalSosEventDetailsPanel = (() => {
    const guessedTimeZone = moment.tz(moment.tz.guess()).format('z')

    var vueComponent = {
        data() {
            return {
                isPanelOpen: false,
                alertDetails: {
                    status: '',
                    createdDate: '',
                    severity: '',
                    title: '',
                    titleLocation: '',
                    categories: '',
                    activeFrom: '',
                    activeTo: '',
                    eventStart: '',
                    eventEnd: '',
                    summary: '',
                    travellerAdvice: '',
                    moreDetail: ''
                },
                isAlertReallyLive: false
            }
        },
        methods: {
            showAlert(alertDetails) {
                this.alertDetails = {
                    status: alertDetails.Status,
                    createdDate: this.getEventFormattedDate(alertDetails.CreatedDate),
                    severity: alertDetails.Severity,
                    title: alertDetails.Title,
                    titleLocation: alertDetails.TitleLocation,
                    categories: alertDetails.Categories,
                    activeFrom: this.getEventSimplifiedDate(alertDetails.ActiveFrom), 
                    activeTo: this.getEventSimplifiedDate(alertDetails.ActiveTo),
                    eventStart: null,
                    eventEnd: null,
                    summary: alertDetails.Summary,
                    travellerAdvice: alertDetails.TravellerAdvice,
                    moreDetail: alertDetails.MoreDetail
                }

                if (alertDetails.EventStart !== null) {
                    this.alertDetails.eventStart = this.getEventFormattedDate(alertDetails.EventStart)
                }

                if (alertDetails.EventEnd !== null) {
                    this.alertDetails.eventEnd = this.getEventFormattedDate(alertDetails.EventEnd)
                }

                // Check to see if Alert is actually live based on date and not cached alert status (Note some ActiveTo data is unavailable so this is not 100% perfect).
                // Might need a rethink if this is important to resolve and will need an up to date response instead. 
                if (moment() <= moment(alertDetails.ActiveTo)) {
                    this.isAlertReallyLive = true
                } else {
                    this.isAlertReallyLive = false
                }

                this.showPanel()
            },
            showPanel() {
                this.isPanelOpen = true
                document.getElementsByClassName('app-template')[0].classList.add('event-detail-panel-show')

                // Reset scroll position
                this.$refs.alertContent.scrollTop = 0
            },
            hidePanel() {
                this.isPanelOpen = false
                document.getElementsByClassName('app-template')[0].classList.remove('event-detail-panel-show')
            },
            getEventFormattedDate(date) {
                return moment(date).format('DD MMM YYYY HH:mm') + ' ' + guessedTimeZone
            },
            getEventSimplifiedDate(date) {
                if (date === '' || date === undefined) return '' 
                return moment(date).format('YYYY-MM-DD HH:mm') + ' ' + guessedTimeZone
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-international-sos-alert-event-details-panel')
    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).mount(DOMElement)
    }
})();
